module.exports = __webpack_public_path__ + "static/img_cta-3.2x-58b22b7cf5a45b268c40e8403bd4d499.svg";